import { getRasterImage, type RasterImageId } from "@/generated/raster-images";

export function rasterLcpPreloadLink(id: RasterImageId) {
  const image = getRasterImage(id);
  return {
    rel: "preload" as const,
    as: "image" as const,
    href: image.lcpAvif,
    type: "image/avif",
    imageSrcSet: image.avifSrcSet,
    imageSizes: "100vw",

    fetchPriority: "high" as const,
  };
}

export function mergeHeadLinks<T extends { links?: unknown[] }>(head: T, extraLinks: unknown[]) {
  return {
    ...head,
    links: [...(head.links ?? []), ...extraLinks],
  };
}
